import React, { useEffect, useContext, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ThemeContext } from '../../App'
import { ISwapFeesBySwapType } from '../../api/interfaces'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

async function getSwapFeesBySwapTypeConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_swap_fees_by_swap_type', timeframe)) as ISwapFeesBySwapType[]

	const series1 = chartData.map((element: ISwapFeesBySwapType) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.STANDARD_FEES }
	})
	const series2 = chartData.map((element: ISwapFeesBySwapType) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.STREAMING_FEES }
	})
	const series3 = chartData.map((element: ISwapFeesBySwapType) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_FEES }
	})
	const series4 = chartData.map((element: ISwapFeesBySwapType) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_FEES_CUMULATIVE }
	})
	const config: IChart[] = [
		{
			data: series4,
			strokeWidth: 2,
			name: 'Cumulative',
			type: 'line',
			seriesGroup: ' [usd]',
			color: `${color}`,
			unitSymbol: '$'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'Total',
			type: 'line',
			seriesGroup: '[usd]',
			color: `${inverseColor}`,
			unitSymbol: '$'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'Fees from Streaming Swaps',
			type: 'bars',
			seriesGroup: '[usd]',
			color: 'orange',
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series1,
			strokeWidth: 2,
			name: 'Fees from Normal Swaps',
			type: 'bars',
			seriesGroup: '[usd]',
			color: 'green',
			unitSymbol: '$',
			barGroup: 'usd'
		}
	]
	return { config: config, latestValue: 0, latestValueDate: 0 }
}

const SwapFeesBySwapType = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getSwapFeesBySwapTypeConfig)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Swap Fees By Swap Type"
			chartDesc="Fees earned from swaps, segmented by swap type. Highlights which contributes most to protocol revenue."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="6b2f83ad-7354-4eb5-90fc-f279825c196b"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
		/>
	)
}

export default SwapFeesBySwapType
